module.exports = __webpack_public_path__ + "img/txs_token.flex.ee751af.png";